module.exports = __webpack_public_path__ + "img/shot_tx19121301.1b51ed9d.jpg";